// extracted by mini-css-extract-plugin
export default {"card-container":"CancelledEmbargoArticle_card-container__fJPum","cardContainer":"CancelledEmbargoArticle_card-container__fJPum"};